import * as React from "react";

// api
import { ApolloProvider } from "react-apollo";
import { configureApollo } from "api";
import { handleGraphlError, handleNetworkError, Navigation, setNotifyConfirm } from "services";
import { ApolloClient } from "apollo-client";
import { NormalizedCacheObject } from "apollo-cache-inmemory";

// redux
import { Provider } from "react-redux";
import { store } from "store";
import { PersistGate } from "redux-persist/integration/react";
import { persistor } from "./store/index";

// moment
import moment from "moment";
import romanianLocale from "./locales/ro";

// styles
import { theme, ThemeProvider, createGlobalStyle } from "styles";
import { Switch, Route } from "react-router";
import { BrowserRouter } from "react-router-dom";

moment.updateLocale("ro", romanianLocale);

import { Main, Public, withAuthCheck } from "./routes";
import { Modal, CircularProgress } from "@material-ui/core";
import { View } from "ui";
import { ErrorConfirm } from "components";
import * as Sentry from "@sentry/browser";

const PrivateRoute = withAuthCheck({ shouldBeAuth: true, redirectTo: "/" });
const PublicRoute = withAuthCheck({ shouldBeAuth: false, redirectTo: "/app" });

const GlobalStyle = createGlobalStyle`
  @font-face{
    font-family: 'Lato';
    src: url('/fonts/Lato-Regular.eot');
    src: url('fonts/Lato-Regular.eot?#iefix') format('embedded-opentype'),
         url('fonts/Lato-Regular.woff') format('woff'),
         url('fonts/Lato-Regular.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
  }
  html{
    font-size: 16px;
    font-family: 'Lato', Helvetica, Arial, sans-serif;

    /* @media screen and (min-width: 900px) {
      font-size: 18px;
    }

    @media screen and (min-width: 1200px) {
      font-size: 20px;
    } */
  }
  body{
    margin: 0;
    padding: 0;
  }
  div[role=progressbar] svg{
    color: ${theme.colors.primary}
  }
  .slick-arrow:before{
    display:none;
  }
`;

Sentry.init({
  dsn: "https://1982483fd65a479e9261fa5b00b63f83@sentry.io/1377338",
  blacklistUrls: ["localhost"],
});
  // should have been called before using it here
  // ideally before even rendering your react app

class Root extends React.Component {
  public state = {
    loading: false,
    error: undefined,
    queryFetched: false,
  };
  public client: ApolloClient<NormalizedCacheObject>;
  constructor(props) {
    super(props);

    this.client = configureApollo({
      onGraphqlError: handleGraphlError,
      onNetworkError: handleNetworkError,
      onRequestStart: (operation) => {
        if (operation.operationName === "getAppData" && this.state.queryFetched){
          return;
        }
        this.setState({ loading: true });
      },
      onRequestEnd: (operation) => {
        if (operation.operationName === "getAppData"){
          this.setState({ queryFetched: true });
        }
        this.setState({ loading: false });
      }
    });

    setNotifyConfirm(this.handleError);
  }
  // public componentDidCatch(error, errorInfo){
  //   Sentry.withScope(scope => {
  //     Object.keys(errorInfo).forEach(key => {
  //       scope.setExtra(key, errorInfo[key]);
  //     });
  //     Sentry.captureException(error);
  //   });
  // }
  public handleError = (error: string) => {
    this.setState({ error });
  }
  public handleErrorClose = () => {
    this.setState({ error: undefined });
  }
  public renderMobile(){
    return (
      <div
        style={{
          display: "table",
          position: "absolute",
          height: "100%",
          width: "100%",
          backgroundColor: "black",
          color: "white"
        }}
      >
        <GlobalStyle />
        <div
          style={{
            padding: "5px",
            display: "table-cell",
            verticalAlign: "middle",
            textAlign: "center",
            fontSize: "17px"
          }}
        >
          <img
            style={{ maxWidth: "100px", maxHeight: "100px" }}
            src={require("assets/logo.png")}
          />
          <h3>Descoperă AutoMemo 6.0!</h3>
          <p style={{ marginLeft: "5%", marginRight: "5%" }}>
            Începând de astăzi, <strong>AutoMemo</strong> are o serie de noi
            beneficii și opțiuni care îți vor face munca și viața de zi cu zi
            mai ușoară!
          </p>
          <p>Descarcă aplicaţia:</p>
          <h3>App Store</h3>
          <a
            style={{ fontSize: "20px", color: "#0088cc" }}
            target="_blank"
            href="http://apple.co/2qveD2M"
          >
            http://apple.co/2qveD2M
          </a>
          <br />
          <h3>Play Store</h3>
          <a
            style={{ fontSize: "20px", color: "#0088cc" }}
            target="_blank"
            href="http://bit.ly/2qU3Z71"
          >
            http://bit.ly/2qU3Z71{" "}
          </a>
        </div>
      </div>
    );
  }
  public render() {
    const { loading, error } = this.state;

    const isMobile = /Android|webOS|iPhone|iPad|iPod|Opera Mini|(Windows Phone)/i.test(
      window.navigator.userAgent
    );
    if (isMobile) {
      return this.renderMobile();
    }

    return (
      <ThemeProvider theme={theme}>
        <ApolloProvider client={this.client}>
          <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
              <GlobalStyle />
              <ErrorConfirm open={!!error} message={error} onClose={this.handleErrorClose} />
              <Modal open={loading}>
                <View
                  width="100%"
                  height="100%"
                  alignItems="center"
                  justifyContent="center"
                  bg="rgba(255,255,255,0.3)"
                >
                  <CircularProgress color="primary" />
                </View>
              </Modal>
              <BrowserRouter>
                <Switch>
                  <PrivateRoute path="/app" component={Main} />
                  <PublicRoute path="/" component={Public} />
                </Switch>
              </BrowserRouter>
            </PersistGate>
          </Provider>
        </ApolloProvider>
      </ThemeProvider>
    );
  }
}

export default Root;



// WEBPACK FOOTER //
// ./src/Root.tsx